import React from 'react';

export interface SVGIconProps {
  src: string;
  alt: string;
  className?: string;
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
  imgClassName?: string;
}

const SVGIcon: React.FC<SVGIconProps> = ({ src, alt, className = '', width, height, style, imgClassName }) => {
  if (!src) {
    return null;
  }

  const normalizedSrc = src.startsWith('//') ? `https:${src}` : src;

  return (
    <div className={`flex size-full items-center justify-center ${className}`} data-testid="atom-svg-icon">
      <img
        src={normalizedSrc}
        alt={alt}
        className={`size-full object-contain ${imgClassName}`}
        width={width}
        height={height}
        style={style}
      />
    </div>
  );
};

export default SVGIcon;
